/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgFontColor = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M576 1025q0-12 5-25l130-324L965 40q7-18 24-27t35-9q20 0 35 8t24 28l254 636 130 324q5 13 5 25 0 26-19 44t-45 19q-20 0-35-11t-24-29l-112-280H811l-112 280q-8 18-23 29t-35 11q-26 0-45-18t-20-45zm610-385-162-404-162 404h324zm542 640q38 0 72 16t61 42 43 61 16 73v384q0 38-16 72t-42 61-61 43-73 16H320q-38 0-72-16t-61-42-43-61-16-73v-384q0-38 16-72t42-61 61-43 73-16h1408zm64 192q0-29-17-46t-47-18H320q-29 0-46 17t-18 47v384q0 28 18 46t46 18h1408q29 0 46-17t18-47v-384z"
    }));
export default SvgFontColor;
